/**
 * Draw order for everything the case map plots.
 *
 * Events sit *above* the machine pins: an event badge is the smaller marker and
 * usually lands within metres of the machine that emitted it, so underneath the
 * pin it is simply invisible.
 *
 * The jumps between tiers are wide because AppMapCluster gives a machine cluster
 * its own point count as a z-index, so any layer that must clear the clusters
 * has to clear a whole page of machines too.
 */
export const Z_INDEX = {
  machine: 100,
  // Clears the machine clusters so the case's own location is never buried by
  // them, but stays under the machines an analyst is actively working.
  address: 500_000,
  selectedMachine: 1_000_000,
  event: 2_000_000,
  openEvent: 3_000_000,
  openAddress: 4_000_000,
};

/**
 * One hue per kind of marker, so colour answers "what is this" at a glance.
 *
 * Orange is the exception and is spent deliberately: it marks the *selected*
 * machine and nothing else, which is why a machine cluster takes the machine
 * hue rather than the brand primary.
 */
export const MARKER_COLOR = {
  machine: "#24B388",
  selectedMachine: "#FF6B35",
  event: "#FACC15",
  // The same blue AppMap gives its address markers, so the case's location
  // looks the same on both maps.
  address: "#057B9F",
};
